// Match the sitemap/canonical format for app navigation without changing assets,
// external links, telephone/email links, or same-document anchors.
export function canonicalPath(to) {
  if (to && typeof to === "object") {
    return to.pathname ? { ...to, pathname: canonicalPath(to.pathname) } : to;
  }
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;
  const [, pathname, suffix] = to.match(/^([^?#]*)(.*)$/);
  if (/\.[^/]+$/.test(pathname)) return to;
  return `${pathname.replace(/\/+$/, "")}/${suffix}`;
}
